import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Mariana G.',
    age: 34,
    role: 'Psicóloga deportiva',
    city: 'Córdoba',
    quote: "Pasé de improvisar y ver 'qué traía el deportista' a tener un proceso claro. El método de 6 fases me ordenó por completo la cabeza y las sesiones.",
    initials: 'MG',
    color: 'bg-blue-100 text-blue-700'
  }, {
    name: 'Federico R.',
    age: 41,
    role: 'Lic. en Psicología',
    city: 'La Plata',
    quote: 'Trabajo con un plantel de fútbol y siempre me costaba estructurar las intervenciones grupales. Las herramientas del kit son oro puro, cero teoría aburrida.',
    initials: 'FR',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    name: 'Lucía M.',
    age: 29,
    role: 'Psicóloga',
    city: 'Rosario',
    quote: 'El bonus del protocolo de primera sesión vale el precio de todo el kit. Me daba mucha inseguridad la primera entrevista y ahora sé exactamente qué preguntar.',
    initials: 'LM',
    color: 'bg-amber-100 text-amber-700'
  }, {
    name: 'Diego A.',
    age: 38,
    role: 'Psicólogo del deporte',
    city: 'Mendoza',
    quote: 'La plantilla para reportar al cuerpo técnico me salvó. Antes no sabía cómo comunicar avances sin romper la confidencialidad. Muy profesional.',
    initials: 'DA',
    color: 'bg-indigo-100 text-indigo-700'
  }, {
    name: 'Camila P.',
    age: 31,
    role: 'Psicóloga deportiva',
    city: 'Mar del Plata',
    quote: 'Excelente la sección de acompañamiento en lesiones. Me dio un mapa clarísimo para trabajar el miedo a la recaída y la confianza corporal.',
    initials: 'CP',
    color: 'bg-rose-100 text-rose-700'
  }];
  return <section className="bg-slate-50 py-12 md:py-20" data-id="element-199">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <h2 className="mb-8 md:mb-12 text-center text-2xl text-slate-900 md:text-4xl font-display" data-id="element-201">
          LO QUE DICEN OTROS PROFESIONALES
        </h2>

        <div className="grid gap-4 md:gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto" data-id="element-202">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-slate-200 flex flex-col ${idx === 3 ? 'md:col-span-1 lg:col-start-2' : ''} ${idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-203">
              <div className="flex gap-1 mb-3" data-id="element-204">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 md:h-4 md:w-4 fill-amber-400 text-amber-400" data-id="element-205" />)}
              </div>
              <p className="text-xs md:text-sm text-slate-600 italic mb-5 flex-1 leading-relaxed" data-id="element-206">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-100" data-id="element-207">
                <div className={`flex h-9 w-9 md:h-10 md:w-10 shrink-0 items-center justify-center rounded-full text-xs font-bold ${t.color}`} data-id="element-208">
                  {t.initials}
                </div>
                <div data-id="element-209">
                  <p className="font-bold text-slate-900 text-[11px] md:text-sm leading-tight" data-id="element-210">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-[10px] md:text-xs text-slate-500 mt-0.5" data-id="element-211">
                    {t.role} · {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}